import React from 'react';
import { FeatureCard } from '@components/ui/cards/FeatureCard';
import { AppointmentsList } from '@features/appointments';

import CalendarIcon from '../../assets/admin-tools.svg?react';
import { useUpcomingRelevantAppointments } from '../../hooks/useUpcomingRelevantAppointments';

/**
 * Shared dashboard component that displays next 3 appointments (filtered to today/tomorrow only)
 * Used by both V1 and V2 dashboard variants
 */
export const AppointmentsListCard: React.FC = () => {
  // Use shared hook to get filtered appointments
  const { appointments, isLoading, hasRelevantAppointments } =
    useUpcomingRelevantAppointments();

  // Don't render if no relevant appointments (today/tomorrow)
  if (isLoading || !hasRelevantAppointments) {
    return null;
  }

  // For V2, this needs to span full width of the grid
  return (
    <FeatureCard
      icon={<CalendarIcon width={20} height={20} fill="currentColor" />}
      title="Upcoming Sessions"
      fullHeight
      sx={{ gridColumn: { xs: '1', md: 'span 2', lg: 'span 3' } }}
    >
      <AppointmentsList
        appointments={appointments}
        showDateHeaders={true}
        defaultExpanded="first"
        analyticsSource="dashboard"
      />
    </FeatureCard>
  );
};
